import Vue from "vue";
import VueRouter from "vue-router";
const originalPush = VueRouter.prototype.push;
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomeIndex",
    meta: {
      // title: "首页"
    },
    component: () => import("../views/home/Index.vue")
  },
  // 证书报名查询系统
  {
    path: "/scanPage",
    name: "scanPage",
    meta: {
      title: "作品详情"
    },
    component: () => import("../views/home/scanPage.vue")
  },
  // 扫码查看学生作品详情
  {
    path: "/bmcx",
    name: "bmcx",
    meta: {
      title: "首页"
    },
    component: () => import("../views/home/bmcx.vue")
  },
  // 首页
  {
    path: "/home",
    name: "Home",
    meta: {
      title: "首页"
    },
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "apply",
        name: "Apply",
        meta: {
          title: "报名"
        },
        component: () => import("../views/home/Apply.vue")
      },
      {
        path: "activityContribute",
        name: "activityContribute",
        meta: {
          title: "报名"
        },
        component: () => import("../views/home/activityContribute.vue")
      },
      {
        path: "affairsQuery",
        name: "affairsQuery",
        meta: {
          title: "赛务查询"
        },
        component: () => import("../views/home/affairsQuery.vue")
      },
      {
        path: "application",  // 扫码报名
        name: "application",
        meta: {
          title: "活动报名"
        },
        component: () => import("../views/home/application.vue")
      },
      {
        path: "queryCheck",
        name: "queryCheck",
        meta: {
          title: "报名信息核对"
        },
        component: () => import("../views/home/queryCheck.vue")
      },

      {
        path: "activityapply",
        name: "ActivityApply",
        meta: {
          title: "活动报名"
        },
        component: () => import("../views/home/ActivityApply.vue")
      },
      {
        path: "payment",
        name: "payment",
        meta: {
          title: "支付"
        },
        component: () => import("../views/home/payment.vue")
      },
      {
        path: "activity",
        name: "Activity",
        meta: {
          title: "作品列表"
        },
        component: () => import("../views/player/Activity.vue")
      },
      // 不知道干啥的
      {
        path: "certificate",
        name: "certificate",
        meta: {
          title: "书法绘画大赛"
        },
        component: () => import("../views/player/certificate.vue")
      },
      {
        path: "newsdetail",
        name: "NewsDetail",
        meta: {
          title: "新闻详情"
        },
        component: () => import("../views/home/NewsDetail.vue")
      },
      {
        path: "remark",
        name: "Remark",
        meta: {
          title: "点评"
        },
        component: () => import("../views/judge/Remark.vue")
      },
      {
        path: "statistics",
        name: "Statistics",
        meta: {
          title: "统计"
        },
        component: () => import("../views/organization/Statistics.vue")
      },
      {
        path: "expert",
        name: "Expert",
        meta: {
          title: "专家"
        },
        component: () => import("../views/channel/Expert.vue")
      }
    ]
  },
  // 选手
  {
    path: "/player",
    name: "Player",
    meta: {
      title: "选手"
    },
    component: () => import("../views/Player.vue"),
    children: [
      {
        path: "photodetail",
        name: "PhotoDetail",
        meta: {
          title: "作品详情"
        },
        component: () => import("../views/player/PhotoDetail.vue")
      },
      {
        path: "mybaby",
        name: "MyBaby",
        meta: {
          title: "学生管理"
        },
        component: () => import("../views/player/MyBaby.vue")
      },
      {
        path: "addbaby",
        name: "AddBaby",
        meta: {
          title: "添加学生"
        },
        component: () => import("../views/player/AddBaby.vue")
      },
      {
        path: "organization",
        name: "myOrganization",
        meta: {
          title: "我的报名服务单位"
        },
        component: () => import("../views/player/Organization.vue")
      }
    ]
  },
  // 评委
  {
    path: "/judge",
    name: "Judge",
    meta: {
      title: "评委"
    },
    component: () => import("../views/Judge.vue"),
    children: [
      {
        path: "remarkpage",
        name: "RemarkPage",
        meta: {
          title: "点评"
        },
        component: () => import("../views/judge/RemarkPage.vue")
      },
      {
        path: "remarkrecord",
        name: "RemarkRecord",
        meta: {
          title: "点评记录"
        },
        component: () => import("../views/judge/RemarkRecord.vue")
      }
    ]
  },
  // 报名服务单位
  {
    path: "/organization",
    name: "Organization",
    meta: {
      title: "报名服务单位"
    },
    component: () => import("../views/Organization.vue"),
    children: [
      {
        path: "search",
        name: "Search",
        meta: {
          title: "搜索"
        },
        component: () => import("../views/organization/Search.vue")
      }
    ]
  },
  // 渠道
  {
    path: "/channel",
    name: "Channel",
    meta: {
      title: "赛事组织单位"
    },
    component: () => import("../views/Channel.vue"),
    children: [
      {
        path: "addexpert",
        name: "AddExpert",
        meta: {
          title: "新增评委"
        },
        component: () => import("../views/channel/AddExpert.vue")
      },
      {
        path: "applyexhibition",
        name: "ApplyExhibition",
        meta: {
          title: "申请展览"
        },
        component: () => import("../views/channel/ApplyExhibition.vue")
      },
      {
        path: "orgmng",
        name: "OrganizationalManagement",
        meta: {
          title: "报名服务单位管理"
        },
        component: () => import("../views/channel/OrganizationalManagement.vue")
      }
    ]
  },
  // 我的
  {
    path: "/mine",
    name: "Mine",
    meta: {
      title: "我的"
    },
    redirect: "/mine/index",
    component: () => import("../views/Mine.vue"),
    children: [
      {
        path: "index",
        name: "MineIndex",
        meta: {
          title: "我的"
        },
        component: () => import("../views/mine/Mine.vue")
      },
      {
        path: "editinfo",
        name: "EditInfo",
        meta: {
          title: "我的信息"
        },
        component: () => import("../views/mine/EditInfo.vue")
      },
      {
        path: "setting",
        name: "Setting",
        meta: {
          title: "设置"
        },
        component: () => import("../views/mine/Setting.vue")
      },
      {
        path: "changephone",
        name: "ChangePhone",
        meta: {
          title: "换绑手机"
        },
        component: () => import("../views/mine/ChangePhone.vue")
      },
      {
        path: "about",
        name: "About",
        meta: {
          title: "关于我们"
        },
        component: () => import("../views/mine/About.vue")
      },
      {
        path: "aboutus",
        name: "AboutUs",
        meta: {
          title: "关于我们"
        },
        component: () => import("../views/mine/AboutUs.vue")
      },

      {
        path: "usinghelp",
        name: "UsingHelp",
        meta: {
          title: "使用帮助"
        },
        component: () => import("../views/mine/UsingHelp.vue")
      },
      {
        path: "feedback",
        name: "Feedback",
        meta: {
          title: "意见反馈"
        },
        component: () => import("../views/mine/Feedback.vue")
      },
      {
        path: "feedbacktype",
        name: "feedbacktype",
        meta: {
          title: "意见反馈"
        },
        component: () => import("../views/mine/FeedbackType.vue")
      },
      {
        path: "feedbackList",
        name: "feedbackList",
        meta: {
          title: "意见反馈"
        },
        component: () => import("../views/mine/feedbackList.vue")
      },
      {
        path: "codeConfirm",// 扫码确认
        name: "codeConfirm",
        component: () => import("../views/mine/codeConfirm.vue")
      },
    ]
  },
  // 如何获取标签
  {
    path: "/getLabel",
    name: "getLabel",
    meta: {
      title: "如何获取标签"
    },
    component: () => import("../views/home/getLabel.vue")
  },
  // 报名流程
  {
    path: "/flowPath",
    name: "flowPath",
    meta: {
      title: "报名流程"
    },
    component: () => import("../views/home/flowPath.vue")
  },
  // 端选择
  {
    path: "/loginchoice",
    name: "LoginChoice",
    meta: {
      title: "登录"
    },
    component: () => import("../views/login/LoginChoice.vue")
  },
  // 选手登录
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登录"
    },
    component: () => import("../views/login/Login.vue")
  },
  // 选手微信登录/注册
  {
    path: "/wxlogin",
    name: "WxLogin",
    meta: {
      title: "微信登录"
    },
    component: () => import("../views/login/WxLogin.vue")
  },
  // 选手注册
  {
    path: "/register",
    name: "Register",
    meta: {
      title: "注册"
    },
    component: () => import("../views/register/Register.vue")
  },
  // 协议
  {
    path: "/useragreement",
    name: "UserAgreement",
    meta: {
      title: "用户协议"
    },
    component: () => import("../views/login/UserAgreement.vue")
  },
  // 评委端登录
  {
    path: "/loginjudge",
    name: "LoginJudge",
    meta: {
      title: "登录"
    },
    component: () => import("../views/login/Judge.vue")
  },
  // 报名服务单位登录
  {
    path: "/loginorg",
    name: "LoginOrg",
    meta: {
      title: "登录"
    },
    component: () => import("../views/login/Organization.vue")
  },
  // 报名服务单位注册
  {
    path: "/orgregister",
    name: "OrganizationRegister",
    meta: {
      title: "报名服务单位注册"
    },
    component: () => import("../views/register/OrganizationRegister.vue")
  },
  // 渠道端登录
  {
    path: "/loginchannel",
    name: "LoginChannel",
    meta: {
      title: "登录"
    },
    component: () => import("../views/login/Channel.vue")
  },
  // 重置密码
  {
    path: "/pwdretrieve",
    name: "PwdRetrieve",
    meta: {
      title: "设置密码"
    },
    component: () => import("../views/mine/PwdRetrieve.vue")
  },
  // 信息补充
  {
    path: "/replenishinfo",
    name: "ReplenishInfo",
    meta: {
      title: "补充作品信息"
    },
    component: () => import("../views/ReplenishPage.vue")
  },
  // 活动列表页
  {
    path: "/activityList/:type",
    name: "activityList",
    meta: {
      title: "赛事活动"
    },
    component: () => import("../views/home/activityList.vue")
  },
  // 新闻资讯列表页
  {
    path: "/informationList",
    name: "informationList",
    meta: {
      title: "新闻资讯"
    },
    component: () => import("../views/home/informationList.vue")
  },
  // 邀请赛区组委会
  {
    path: "/inviteChannel",
    name: "inviteChannel",
    meta: {
      title: "邀请赛事组织单位"
    },
    component: () => import("../views/invite/channel.vue")
  },
  // 邀请报名服务单位
  {
    path: "/inviteMechanism",
    name: "inviteMechanism",
    meta: {
      title: "邀请报名服务单位"
    },
    component: () => import("../views/invite/mechanism.vue")
  },
  // 邀请专家
  {
    path: "/inviteJudge",
    name: "inviteJudge",
    meta: {
      title: "邀请专家"
    },
    component: () => import("../views/invite/judge.vue")
  },

  // 问卷调查
  {
    path: "/question",
    name: "question",
    meta: {
      title: "问卷调查"
    },
    component: () => import("../views/question/index.vue")
  },
  // 纸质证书申领
  {
    path: "/cert",
    name: "cert",
    meta: {
      title: "证书申领列表"
    },
    component: () => import("../views/cert/index.vue")
  },
  // 纸质证书申领
  {
    path: "/cert/apply",
    name: "certApply",
    meta: {
      title: "填写收件信息"
    },
    component: () => import("../views/cert/apply.vue")
  },
  // 纸质证书申领
  {
    path: "/cert/detail",
    name: "certDetail",
    meta: {
      title: "订单详情"
    },
    component: () => import("../views/cert/detail.vue")
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
